export enum ConsentTypeEnum {
  writerConsent = 'WRITER_CONSENT',
  termsOfUse = 'TERMS_OF_USE',
  privacyPolicy = 'PRIVACY_POLICY',
}
